<template>
  <!---处理状态---->
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="closeDialog"
      :show-close="showClose"
      :close-on-click-modal="closeOnClickModal"
      :close-on-press-escape="closeOnPressEscape"
      :typeID="typeID"
      width="600px"
      @opened="opened"
    >
      <div class="dispose">
        <div class="dispose-title">处置状态</div>
        <div class="radio">
          <el-button
            :type="dealStatus === '0' ? 'primary' : 'default'"
            @click="dealStatus = '0'"
            >处置中</el-button
          >
          <el-button
            :type="dealStatus === '1' ? 'primary' : 'default'"
            @click="dealStatus = '1'"
            >已处置</el-button
          >
          <div class="warning-tips" v-show="showTips1">请选择处置状态</div>
        </div>
        <div class="dispose-title">处置过程和结果</div>
        <el-form ref="form" label-width="80px" class="form">
          <el-input
            type="textarea"
            v-model="warningDealDesc"
            placeholder="请输入处置内容..."
            :rows="8"
          ></el-input>
        </el-form>
        <div class="warning-tips" v-show="showTips2">请输入处置内容</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确 定</el-button>
        <el-button @click="closeDialog">返 回</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    dialogVisible: Boolean,
    showClose: {
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: true
    },
    showCancelFlag: {
      type: Boolean,
      default: true
    },
    typeID: {
      type: String,
      default: ''
    },
    warningId: {
      type: String,
      default: ''
    },
    closeDialog: Function
  },
  data() {
    return {
      dealStatus: '',
      warningDealDesc: '',
      showTips1: false,
      showTips2: false
    };
  },
  mounted() {},
  methods: {
    opened() {
      this.dealStatus = '';
      this.warningDealDesc = '';
    },
    submit() {
      this.showTips1 = !this.dealStatus;
      this.showTips2 = !this.warningDealDesc;
      if (this.showTips1 || this.showTips2) {
        return;
      }
      this.$request({
        url: 'rest/riskWarningDeal/saveRiskWarningDealInfo',
        data: {
          json: JSON.stringify({
            params: {
              dealStatus: this.dealStatus,
              warningDealDesc: this.warningDealDesc,
              warningId: this.warningId
            }
          })
        }
      }).then(res => {
        this.$alert('操作成功');
        this.closeDialog('isReload');
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import './common.styl'
.dispose
  margin -30px 43px 0 43px
  .dispose-title
    color #444
    font-size 14px
  .radio
    margin 15px 0
  .form
    margin 15px 0 0 0
.warning-tips
  color #F56C6C
  font-size 12px
  margin-top 5px
</style>
